import {
    Pagination,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableFooter,
    TableHeader,
    WindmillContext,
    TableRow
} from "@windmill/react-ui";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import SalesLineChart from "components/chart/LineChart/SalesLineChart";

import BarChartComponent from "components/chart/barChart/SalesbarChart";
import ChartCardone from "components/chart/ChartCardone";

import SalesCardItemOne from "components/dashboard/SalesCarditem-one";
import SalesCardItemtwo from "components/dashboard/transportcarditems";

import TableLoading from "components/preloader/TableLoading";
import NotFound from "components/table/NotFound";
import PageTitle from "components/Typography/PageTitle";

import { SidebarContext } from "context/SidebarContext";
import useAsync from "hooks/useAsync";
import useFilter from "hooks/useFilter";
import sidebar from "routes/sidebar";

import DashboardServices from "services/DashboardServices";

import currentmonthvalueamountimg
    from "../../assets/salesdashboaricons/currentmonthvalueimg.webp";

import currentmonthreceivedamountimg
    from "../../assets/salesdashboaricons/receivedamountimg.webp";

import currentmonthreceivableamount
    from "../../assets/salesdashboaricons/receivableamountimg.webp";

import totalrecievableamount from "../../assets/salesdashboaricons/totalreceivableamountimg.webp";

import "../dashboardComponents/Accountsalesdashboard.css"

import inactiveagenticon from "../../assets/salesdashboaricons/inactiveagent.webp";
import partiallyreceivedicon
    from "../../assets/salesdashboaricons/partiallyreceived.webp";
import receivablesalesicon
    from "../../assets/salesdashboaricons/receivablesales.webp";
import totalsaleicon
    from "../../assets/salesdashboaricons/totalsale.webp";

import receivedsaleicon
    from "../../assets/salesdashboaricons/receivedsale.webp";
const GRAPHTYPE = {
    week: 1,
    month: 2,
    year: 3,
};
const AccountsSalesDashboard = () => {
    const { globalSetting } = useFilter();
    const { mode } = useContext(WindmillContext);
    const { currentPage, handleChangePage, lang } =
        useContext(SidebarContext);
    const { t } = useTranslation();
    const currency = globalSetting?.default_currency || "₹";

    const [view, setView] = useState("month"); // default tab
    const [chartData, setChartData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [percentageChange, setPercentageChange] = useState(0);


    const adminInfo = localStorage.getItem("adminInfo")
        ? JSON.parse(localStorage.getItem("adminInfo"))
        : null;
    const employeeId = adminInfo?.id
    const {
        data: dashboardData,
        loading: loadingOrderAmount,
        error,
    } = useAsync(() => DashboardServices.getProfileDashboard(employeeId));
    useEffect(() => {
        // console.log("Loading:", loadingOrderAmount);
        //   console.log("Data:", dashboardData);
    }, [loadingOrderAmount, dashboardData]);

    const formatDateDMY = (iso) => {
        if (!iso) return "-";
        return new Date(iso).toLocaleDateString("en-GB", {
            timeZone: "UTC",
        });
    };

    useEffect(() => {
        const fetchSalesGraph = async () => {
            try {
                setLoading(true);

                const type = GRAPHTYPE[view];
                const res = await DashboardServices.getDashboardGraphSale(type);
                // console.log("----resposne", res);

                const saleStats = res?.data?.sale_stats?.chart_data || [];
                // console.log("graph data with type", saleStats);

                const percentage = res?.data?.sale_stats?.percentage_change || 0;

                setPercentageChange(Number(percentage));

                const normalizedData = saleStats.map((item) => ({
                    label: item.label,
                    total: Number(item.total) || 0,
                }));

                setChartData(normalizedData);
                setPercentageChange(percentage);
            } catch (error) {
                console.error("Sales graph API error:", error);
                setChartData([]);
            } finally {
                setLoading(false);
            }
        };

        fetchSalesGraph();
    }, [view]);


    return (
        <>
            <PageTitle sidebar={sidebar().sidebar} />
            <h1
                style={{
                    color: "black",
                    fontWeight: 600,
                    fontSize: "20px",
                }}
            >
                Current Month Status
            </h1>

            <div className="grid gap-4 mb-8 md:grid-cols-4">

                <SalesCardItemtwo
                    mode={mode}
                    currency={currency}

                    title2="Current Month Sale Values"
                    Img={currentmonthvalueamountimg}
                    price={dashboardData?.data?.sales?.monthly_sales || 0}
                    className="bg-white text-black"
                    loading={loadingOrderAmount}
                    onNavigation='/sales'
                    current_month={true}
                    type={3}
                />
                <SalesCardItemtwo
                    mode={mode}
                    currency={currency}
                    title2="Received Amounts"
                    Img={currentmonthreceivedamountimg}
                    price={dashboardData?.data?.sales?.monthly_received || 0}
                    className="bg-white text-black"
                    loading={loadingOrderAmount}
                    onNavigation='/sales'
                    current_month={true}
                    type={2}
                />
                <SalesCardItemtwo
                    mode={mode}
                    currency={currency}
                    title2="Receivable Amounts"
                    Img={currentmonthreceivableamount}
                    price={dashboardData?.data?.sales?.monthly_receivable || 0}
                    className="bg-white text-black"
                    loading={loadingOrderAmount}
                    onNavigation='/sales'
                    current_month={true}
                    type={1}
                />
                <SalesCardItemtwo
                    mode={mode}
                    currency={currency}

                    title2="Total Receivable Amounts"
                    Img={totalrecievableamount}
                    price={dashboardData?.data?.sales?.total_receivable || 0}
                    className="bg-white text-black"
                    loading={loadingOrderAmount}
                // onNavigation='/sales'
                />
            </div>

            <div className="grid gap-4 md:grid-cols-5 ">
                <SalesCardItemOne
                    card_bg_color='#D7FFDE'
                    title="Total Sales"
                    Img={totalsaleicon}
                    quantity={dashboardData?.data?.sales?.monthly_sale_count || 0}
                    onNavigation='/sales'
                    current_month={true}
                    type={3}
                />
                <SalesCardItemOne
                    card_bg_color='#FFF3D7'
                    title="Received Sales"
                    Img={receivedsaleicon}
                    quantity={dashboardData?.data?.sales?.monthly_received_count || 0}
                    onNavigation='/sales'
                    current_month={true}
                    type={2}
                />
                <SalesCardItemOne
                    card_bg_color='#D7DBFF'
                    title="Receivable Sales"
                    Img={receivablesalesicon}
                    quantity={dashboardData?.data?.sales?.monthly_receivable_count || 0}
                    onNavigation='/sales'
                    current_month={true}
                    type={1}


                />
                <SalesCardItemOne
                    card_bg_color='#FED7FF'
                    title="Partially Received Sales"
                    Img={partiallyreceivedicon}
                    quantity={dashboardData?.data?.sales?.monthly_pending_count || 0}
                    onNavigation='/sales'
                    current_month={true}
                    type={1}
                    partially_status={true}


                />
                <SalesCardItemOne
                    card_bg_color='#FFD7D8'
                    title="Inactive Agents"
                    Img={inactiveagenticon}
                    quantity={dashboardData?.data?.sales?.inactive_agent_count || 0}
                    onNavigation='/agentslist'
                    agent_status={true}
                />
            </div>

            <div className="flex flex-wrap justify-between my-8 w-full ">
                <ChartCardone
                    cardsize='60'
                    mode={mode}
                    loading={loadingOrderAmount}
                    title={t("")}
                >
                    <SalesLineChart
                        percentageChange={percentageChange}
                        view={view}
                        onViewChange={setView}
                        data={chartData}
                        loading={loading}

                    />
                </ChartCardone>

                <ChartCardone
                    cardsize='38'
                    mode={mode}
                    loading={loadingOrderAmount}

                >
                    <BarChartComponent salesReport={dashboardData} />
                </ChartCardone>
            </div>
            <h1 className=" font-bold mb-3 mt-1" style={{ fontSize: "24px" }}>
                Recent Sales
            </h1>

            {loadingOrderAmount ? (
                <TableLoading row={5} col={7} />
            ) : dashboardData?.data?.recent_sales?.length > 0 ? (
                <TableContainer>
                    <Table>
                        <TableHeader className="text-center">
                            <tr className="text-sm">
                                <TableCell >SI.NO</TableCell>
                                <TableCell>Booking ID</TableCell>
                                <TableCell >Client Name</TableCell>
                                <TableCell>Travel Date</TableCell>
                                <TableCell>Receivable Amount</TableCell>
                                <TableCell>Received Amount</TableCell>
                                <TableCell>Received Date</TableCell>
                                <TableCell>Payment Type</TableCell>
                                <TableCell>Status</TableCell>
                            </tr>
                        </TableHeader>

                        <TableBody>
                            {dashboardData?.data?.recent_sales?.map((row, index) => (

                                <TableRow key={index} className="text-center">
                                    <TableCell>{index + 1}</TableCell>
                                    <TableCell >
                                        <div className="pt-2 text-blue-400">
                                            <span className="text-sm">{row.booking_id || '-'}</span>
                                        </div>
                                    </TableCell>
                                    <TableCell>{row.client_name}</TableCell>

                                    <TableCell className="text-center">
                                        {row.start_date && row.end_date ? (
                                            <>
                                                <div>{formatDateDMY(row.start_date || '-')}</div>
                                                <div className="pt-3">{formatDateDMY(row.end_date || '-')}</div>
                                            </>
                                        ) : (
                                            "-"
                                        )}
                                    </TableCell>


                                    <TableCell>{row.receivable_amt || '-'}</TableCell>
                                    <TableCell>{row.received_amt}</TableCell>
                                    <TableCell>{formatDateDMY(row.received_date || '-')}</TableCell>
                                    <TableCell>{row.payment_type || '-'}</TableCell>
                                    <TableCell>{row.status}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            ) : (
                <NotFound title="No recent purchase  found" />
            )}

        </>
    );
};

export default AccountsSalesDashboard;